import {
  IPayrollKpi,
  IPayrollPeriodPoint,
  IPayrollDeptRow,
  IOvertimeDeptRow,
} from '../hrAnalytics.types'

export const MOCK_PAYROLL_KPIS: IPayrollKpi[] = [
  {
    value: '$376K',
    label: 'TOTAL PAYROLL COST',
    accentColor: '#30B6D1',
    iconKey: 'dollar',
  },
  {
    value: '$291K',
    label: 'BASIC SALARY TOTAL',
    sublabel: '77.4% of total payroll',
    accentColor: '#00B04C',
    iconKey: 'dollar',
  },
  {
    value: '$52K',
    label: 'OVERTIME TOTAL',
    sublabel: '77.4% of total',
    trend: { value: '-8.2%', positive: false },
    accentColor: '#ff9900',
    iconKey: 'dollar',
  },
  {
    value: '$33K',
    label: 'ALLOWANCES TOTAL',
    sublabel: 'Responsibility + Extra Duty + Other',
    accentColor: '#00B04C',
    iconKey: 'checkCircle',
  },
  {
    value: '$42.5K',
    label: 'TOTAL DEDUCTIONS',
    sublabel: 'SSNI + tax + other',
    accentColor: '#ff9900',
    iconKey: 'warning',
  },
  {
    value: '$333.5K',
    label: 'NET SALARY TOTAL',
    accentColor: '#00B04C',
    iconKey: 'dollar',
  },
]

export const MOCK_PAYROLL_PERIOD: IPayrollPeriodPoint[] = [
  { month: 'Jan 2024', basicSalary: 40000, overtime: 8000, allowances: 5000, deductions: 6000 },
  { month: 'Feb 2024', basicSalary: 63000, overtime: 7000, allowances: 5000, deductions: 5000 },
  { month: 'Mar 2024', basicSalary: 20000, overtime: 5000, allowances: 5000, deductions: 10000 },
  { month: 'Apr 2024', basicSalary: 40000, overtime: 8000, allowances: 5000, deductions: 6000 },
]

export const MOCK_PAYROLL_BY_DEPT: IPayrollDeptRow[] = [
  { name: 'Lorem ipsum', headcount: 80, totalCost: '$145,000', basic: '$110,000', overtime: '$22,000', allowances: '$13,000' },
  { name: 'Lorem ipsum', headcount: 40, totalCost: '$75,000', basic: '$60,000', overtime: '$12,000', allowances: '$6,000' },
  { name: 'Lorem ipsum', headcount: 45, totalCost: '$55,000', basic: '$40,000', overtime: '$8,000', allowances: '$4,000' },
  { name: 'Lorem ipsum', headcount: 32, totalCost: '$38,000', basic: '$29,000', overtime: '$5,500', allowances: '$3,500' },
  { name: 'Lorem ipsum', headcount: 22, totalCost: '$35,000', basic: '$28,000', overtime: '$3,000', allowances: '$4,000' },
  { name: 'Lorem ipsum', headcount: 18, totalCost: '$28,000', basic: '$24,000', overtime: '$1,500', allowances: '$2,500' },
]

export const MOCK_OVERTIME_BY_DEPT: IOvertimeDeptRow[] = [
  { name: 'Mining Ops', amount: 22000, label: '$22.0K' },
  { name: 'Maintenance', amount: 12000, label: '$12.0K' },
  { name: 'Processing', amount: 8000, label: '$8.0K' },
  { name: 'Fleet', amount: 5500, label: '$5.5K' },
  { name: 'HSE & Safety', amount: 3000, label: '$3.0K' },
  { name: 'Admin', amount: 1500, label: '$1.5K' },
]
